import { useLocalVariants } from './useLocalVariants';

export const useSkipOneDayEmailVerificationLatency = () => {
  const skipOneDayEmailVerificationLatency = useLocalVariants(
    'useSkipOneDayEmailVerificationLatencyV2'
  );
  return skipOneDayEmailVerificationLatency === 'enabled';
};
